import { FC, ReactNode } from "react";

import Box from "@mui/material/Box";
import { SxProps, Theme } from "@mui/material/styles";

import styles from "./styles";

export type CardProps = {
  children: ReactNode;
  plain?: boolean;
  bg?: string;
  clickable?: boolean;
  border?: boolean;
  onClick?: () => void;
  sx?: SxProps<Theme>;
  light?: boolean;
  shadow?: boolean;
};

const Card: FC<CardProps> = ({
  children,
  plain,
  bg,
  clickable,
  border,
  shadow,
  sx = [],
  light = false,
  ...rest
}) => {
  return (
    <Box
      sx={[
        styles.card,
        plain && styles.plain,
        bg && styles[bg],
        clickable && styles.clickable,
        border && styles.border,
        light && styles.light,
        shadow && styles.shadow,
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...rest}
    >
      {children}
    </Box>
  );
};

export default Card;
